
// export default i18n
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import japan from './japan'
import tc from './tc'
import korean from './korean'


Vue.use(VueI18n);

const messages = {
  kr: korean,
  tw: tc,
  jp: japan,
};

export const i18n = new VueI18n({
  locale: 'tw', // 默认语言
  fallbackLocale: 'jp', // 当指定的语言不可用时，使用的备选语言
  messages,
});
